<template>
  <div class="iptBox">
    <el-form
      :model="loginForm"
      ref="validateForm"
      label-width="100px"
      @validate="onValidate"
      :status-icon="true"
      class="specialBox"
    >
      <el-form-item label="" prop="Name" id="ipt" :rules="rules.Name">
        <div class="iptBoxIn">
          <div><i class="el-icon-user-solid icon"></i></div>
          <el-input v-model="loginForm.Name" placeholder="手机号码" clearable>
            <!-- <i slot="prefix" class="el-icon-user-solid icon"></i> -->
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="" prop="Pwd" id="ipt" :rules="rules.Pwd">
        <div class="iptBoxIn">
          <div><el-icon class="el-icon-unlock icon"></el-icon></div>
          <el-input
            v-model="loginForm.Pwd"
            placeholder="密码"
            show-password
            clearable
          >
          </el-input>
        </div>
      </el-form-item>
      <div class="forgetPsd">
        <el-checkbox v-model="checked">记住密码</el-checkbox>
        <div class="tipBox">公共场所不建议记住账号密码,以防账号丢失</div>
      </div>

      <el-button
        :class="!validatePass ? 'signBtn currenBtn' : 'signBtn'"
        :loading="loading"
        @click="handleLogin"
        type="primary"
        :disabled="!validatePass"
      >
        登录
      </el-button>

      <!-- <div>{{ validatePass }}</div> -->
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value == "") {
        return callback(new Error("手机号不能为空"));
      } else {
        // const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        const reg = /^[0-9]\d{10}$/;

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      checked: true,
      // 表单是否整体通过验证
      validatePass: false,
      loginForm: {
        Name: "",
        Pwd: "",
        Brower: "Browser",
      },
      loading: false,
      rules: {
        Name: [{ validator: checkPhone, trigger: "change", required: true }],
        Pwd: [{ required: true, message: "请输入密码", trigger: "change" }],
      },
    };
  },
  computed: {},
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$refs.validateForm.clearValidate();
    let Account = localStorage.getItem("Account");
    let Password = localStorage.getItem("Password");
    if (
      Password != "" &&
      Account != "" &&
      Password != null &&
      Password != undefined &&
      Account != null &&
      Account != undefined
    ) {
      this.loginForm.Name = Account;
      this.loginForm.Pwd = Password;
    }
    // console.log(this.$refs.validateForm.fields)
    this.updateFormValidateStatus();
  },
  methods: {
    updateFormValidateStatus() {
      this.$nextTick(() => {
        let validateStateArr = [];
        if (this.$refs.validateForm) {
          validateStateArr = this.$refs.validateForm.fields.map((item) => {
            if (item.validateState) {
              return item.validateState;
            } else if (item.rules && item.rules.length > 0) {
              return "error";
            } else {
              return "success";
            }
          });
        }
        this.validatePass =
          validateStateArr.find((item) => item === "error") !== "error";
      });
    },
    onValidate(...args) {
      // console.log("args", args)
      this.updateFormValidateStatus();
    },

    handleLogin() {
      this.$refs.validateForm.validate((valid) => {
        this.loading = true;
        if (valid) {
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              // this.$router.push({
              //   path: "/",
              // });
              this.$emit("closeDialog", false);
              this.$router.push({
                path: "/",
                // path: this.redirect || "/",
                query: this.otherQuery,
              });
              // this.$router.push({
              //   path: "/redirect/",
              //   query: this.otherQuery,
              // });
              this.loading = false;
              if (this.checked == true) {
                localStorage.setItem("Account", this.loginForm.Name);
                localStorage.setItem("Password", this.loginForm.Pwd);
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scope>
.iptBox {
  // .el-input__inner {
  // 	color: #000;
  // }
  // .el-input__suffix {
  // 	display: none;
  // }

  .icon {
    background: #cccccc;
    width: 50px !important;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 30px;
  }
  .iptBoxIn {
    display: flex;
    // flex: 1;
  }

  .el-input {
    // padding: 0 0px 0 10px;
  }
  .specialBox {
    .el-input__inner {
    }
    .el-input__prefix {
      display: flex;
      justify-content: flex-start;
    }
    .currenBtn {
      opacity: 0.6;
    }
    .signBtn {
      margin-top: 20px;
      padding: 14px 0;
      width: 100%;
      // border: none;
      // border-radius: 4px;
      // color: #fff;
      // background: #ffa78d;
    }
    .el-input__validateIcon {
      display: none;
    }
    .el-button--primary {
      background-color: #ff4f1a;
      border-color: #ff4f1a;
      color: #fff;
      // padding: 10px 20px;
      font-size: 16px;
    }
    .el-button--primary:hover {
      background-color: #ff4f1a;
      border-color: #ff4f1a;
      color: #fff;
      // padding: 10px 20px;
      font-size: 16px;
    }
  }

  .forgetPsd {
    // display: flex;
    // justify-content: space-between;
    word-wrap: break-word;
    vertical-align: middle;
    .el-checkbox__inner {
      border: 1px solid #606266;
    }
    .tipBox {
      // vertical-align: middle;
      // margin-left: 16px;
      line-height: 21px;
      font-size: 14px;
      background: #fdf5f2;
      color: #fe7648;
    }
    .colorHover {
      font-size: 12px;
      cursor: pointer;
    }
    .colorHover:hover {
      color: #ff4f1a;
      text-decoration: underline;
    }
  }
  .el-checkbox__label {
    font-size: 14px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 36px;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-input--small .el-input__inner {
    border: none !important;
    background: #f2f2f2;

    width: 100%;
    height: 50px;
    // padding: 0 30px;
  }
}
</style>
